export default "__VITE_PUBLIC_ASSET__71ee8aef__"